import { RuntimeEnvironmentOptions, getEnvFromHostname } from '@growtherapy/analytics';

export type SegmentProxyLocations = {
  /** Replaces `cdn.segment.com`. Full origin, including protocol. */
  cdnUrl: string;
  /** Replaces `api.segment.io/v1`. Host WITHOUT protocol. */
  apiHost: string;
};

export type SegmentConfig = {
  segmentWriteKey: string;
  segmentProxyLocations?: SegmentProxyLocations;
};

export function getSegmentConfig(): SegmentConfig {
  const env = getEnvFromHostname({ hostname: window.location.hostname });
  switch (env) {
    case RuntimeEnvironmentOptions.production:
      return {
        segmentWriteKey: 'h4fMRkcCYrVqDzBGMzj7yRbXa0vYilHN',
        segmentProxyLocations: {
          cdnUrl: 'https://growtherapy.com/a/cdn',
          apiHost: 'growtherapy.com/a/api/v1',
        },
      };
    case RuntimeEnvironmentOptions.staging:
      return {
        segmentWriteKey: 'SXuhdNATcYd1Hf2RMy4EFAQDkp05nx9g',
        segmentProxyLocations: {
          cdnUrl: 'https://growtherapystaging.com/a/cdn',
          apiHost: 'growtherapystaging.com/a/api/v1',
        },
      };
    case RuntimeEnvironmentOptions.local:
      return {
        segmentWriteKey: 'oOsNlwHUnzTwyf1ZStjhsYeW0R2U8utZ',
      };
    default:
      return {
        segmentWriteKey: 'oOsNlwHUnzTwyf1ZStjhsYeW0R2U8utZ',
      };
  }
}
